module.exports = __webpack_public_path__ + "img/coin-two-img.a464dfd6.png";